module.exports = __webpack_public_path__ + "img/meter-off-green.e701b58d.svg";